// extracted by mini-css-extract-plugin
export default {"divider":"Login_divider__-hyzY"};